<template>
  <div id="store-locator" class="bg-light position-relative">

    <div id="filtersMap" :class="[{ 'position-sticky': filterSticky },{ 'position-absolute': !filterSticky}, 'search']">
      <div class="container">
        <div class="row">
        <div class="col-8 col-xs-12 position-relative">
          <div v-if="viewRange" class="range px-4 bg-white position-absolute">
            <span class="badge w-100" :data-prebadge="labelRaggio" :data-badge="rangeLabel" data-initial="YZ">
              <input class="slider" ref="rangeInput" type="range" min="0" max="400" v-model="range">
            </span>
          </div>
          <div class="input-group">
            <span class="input-group-text p-0 bg-white border-0 d-flex align-items-center">
              <span class="input-group-text bg-transparent border-0">
                  <i class="bi bi-search fs-5"></i>
              </span>
            </span>
            <gmap-autocomplete :value="placeLabel" :placeholder="placeholderLabel" class="form-control border-0 py-2 fs-5 fw-normal bg-white"
                @place_changed="setPlace">
            </gmap-autocomplete>
            <span v-if="showClear" @click="reset" class="btn btn-link p-0 input-group-text bg-white border-0 d-flex align-items-center">
                <span class="input-group-text bg-transparent border-0">
                    <i class="bi bi-x-lg fs-5 mt-1"></i>
                </span>
            </span>
            <span @click="myPosition" class="btn btn-link p-0 input-group-text bg-white border-0 d-flex align-items-center">
                  <span class="input-group-text bg-transparent border-0">
                      <i class="bi bi-pin-map-fill fs-5 mt-1"></i>
                  </span>
              </span>
          </div>
        </div>
        <div class="col-4 col-xs-12 map-view">
          <div v-if="isLista" :class="[{ active: isMappa }, 'map-view-mappa btn btn-primary fw-semibold fs-6']" @click="viewMappa">
            {{ labelMappa }}
          </div>
          <div v-if="isMappa" :class="[{ active: isLista }, 'map-view-lista btn btn-primary fw-semibold fs-6']" @click="viewLista">
             {{ labelLista }}
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="container-fluid">
      <div v-if="loading" class="loading d-flex justify-content-center align-items-center w-100 h-100 position-absolute">
        <div class="spinner-border m-5" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="row map-wrapper position-relative" :class="[classMappa]">

          <div v-if="isLista" class="lista w-100 h-100 bg-light col-12 mb-4 ">
           <!--<simplebar id="lista-store" class="scroll" data-simplebar-auto-hide="false">-->
            <div class="container">
              <div class="row">
                <div v-for="(m, i) in resultsElement" :key="i" 
                  :class="[{ active: currentMidx == i && infoWinOpen }, 'col-12 col-md-6 mb-3']" @click.prevent="toggleInfoWindow(m, i)">
                  <div class="card border-0 bg-white">
                    <div class="card-body">
                      <h5 class="card-title text-uppercase fw-semibold fs-3">{{ m.placeResult.name }}</h5>
                      <p class="card-text m-0"><i class="bi bi-whatsapp"></i> {{ m.placeResult.whatsapp }}</p>
                      <p class="card-text m-0"><i class="bi bi-telephone"></i> {{ m.placeResult.phone }}</p>
                      <p class="card-text m-0"><i class="bi bi-pin-map-fill"></i> {{ m.placeResult.address }}</p>
                      <p class="card-text m-0"><i class="bi bi-envelop"></i> {{ m.placeResult.email }}</p>
                      <a class="btn btn-primary mt-4"  href="#" @click.stop @click.prevent="goTo(m.placeResult.url)" title="">{{ labelVisitaCentro }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--</simplebar>-->
          </div>


          <div v-if="isMappa" class="col-12 mappa">
            <gmap-map :center="center" :zoom="zoom" ref="map" style="width: 100%; height: 100%" :options="optionsMap">
              <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
                @closeclick="infoWinOpen = false">
              </gmap-info-window>
              <gmap-marker :key="index" v-for="(m, index) in resultsElement" :position="m.position" :clickable="true"
              :draggable="false" @click="toggleInfoWindow(m, index)" :icon="pinPath" />
            </gmap-map>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { gmapApi } from 'gmap-vue';
import axios from 'axios';
// import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css';
import { mapStyle } from './mapstyle';


window.getItineraire = function (lat, lng, mylat, mylng) {
  var saddr = "";
  if (typeof mylat != "undefined" && typeof mylng != "undefined")
    saddr = "saddr=" + mylat + "," + mylng + "&";

  window.open("http://maps.google.com/maps?" + saddr + "daddr=" + lat + "," + lng, "_blank");
  return;
}


export default {
  name: 'App',
  computed: {
    google: gmapApi,
    viewRange() {
      return this.place || this.myPos;
    },
    labelRaggio() {
      return window.TLSSLOptions.labelRaggio;
    },
    labelMappa() {
      return window.TLSSLOptions.labelMappa;
    },
    labelLista() {
      return window.TLSSLOptions.labelLista;
    },
    labelVisitaCentro() {
      return window.TLSSLOptions.labelVisitaCentro;
    },
    placeholderLabel() {
      return window.TLSSLOptions.labelCercaCentro;
    },
    clearLabel() {
      return "Visualizza tutti i " + this.markers.length + " negozi"
    },
    showClear() {
      return this.place || this.myPos;
    },
    pinPath() {
      return this.assetsPath + "pin.png";
    },
    clusterPath() {
      return this.assetsPath + "Icon_store_";
    },
    radius() {
      return this.range * 1000
    },
    rangeLabel() {
      return this.range + ' km';
    },
    placeLabel() {
      let address = '';
      if (this.place) {
        if (this.place.address_components) {
          address = [
            (this.place.address_components[0] && this.place.address_components[0].short_name || ''),
            (this.place.address_components[1] && this.place.address_components[1].short_name || ''),
            (this.place.address_components[2] && this.place.address_components[2].short_name || '')
          ].join(' ');
        }
      }
      return address;
    }

  },
  data() {
    return {
      windowTop: 0,
      filterSticky: false,
      isMappa: true,
      isLista: false,
      classMappa: 'view-mappa',
      resetC: false,
      center: { 
        lat: 41.9027835, 
        lng: 12.4963655 
      },
      latLng: {
        lat: 41.9027835,
        lng: 12.4963655
      },
      stores: {},
      notFoundLabel: '',
      zoom: 7,
      loading: false,
      markers: [],
      bounds: [],
      resultsElement: [],
      place: null,
      myPos: null,
      range: 25,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -65
        }
      },
      optionsMap: {
        zoom: 7,
        minZoom: 4,
        maxZoom: 14,
        center: { lat: 41.9027835, lng: 12.4963655 },
        zoomControl: true,
        panControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        styles: mapStyle
      }
    }
  },
  components: {
    //GmapCluster,
    // simplebar
  },
  async created() {
    this.loading = true;
    await this.$gmapApiPromiseLazy();
    let stores = await this.getMarkers();
    this.stores = stores;
    this.log('loaded stores', stores.data);
    this.setMarkersInit(stores.data);
  },
  mounted(){
    window.addEventListener("scroll", this.onScroll);
    //this.myPosition();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    goTo(url) {
      var cleanUrl = this.cleanUrl(url);
      window.open(cleanUrl);
    },
    cleanUrl(url) {
      return url.replace(/([^:]\/)\/+/g, "$1");
    },
    onScroll() {
      this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
      if(this.windowTop >= 186){
        this.filterSticky = true;
      }else{
        this.filterSticky = false;
      }
    },
    viewMappa() {
      this.isMappa = true;
      this.isLista = false;

      this.classMappa = this.isMappa ? 'view-mappa' : 'view-lista';
      setTimeout(() => {
        this.fitBounds();
      }, 1000);
    },
    viewLista() {
      this.isMappa = false;
      this.isLista = true;
      this.classMappa = this.isMappa ? 'view-mappa' : 'view-lista';
    },
    getMarkers() {
      this.log('isdev', this.isDev);
      if (typeof window.TLSSLOptions !== "undefined") {
        let url = window.TLSSLOptions.ajaxurl;
        let data = new FormData;
        data.append('action', window.TLSSLOptions.action);
        data.append('nonce', window.TLSSLOptions.nonce);
        return axios.post(url, data)
      }
      // caricamento json statico per test 
      return axios.get('stores.json')
    },
    toggleInfoWindow: function (marker, idx) {
      this.center = marker.position
      this.infoWindowPos = marker.position;
      this.infoOptions.content = this.renderStoreInfo(marker)

      // controlla se il click è sullo stesso pin lo chiude altrimenti apre quello nuovo
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    renderStoreInfo(m) {
      let content = '';
      content = '<div class="card border-0 bg-white">';
      content += '<div class="card-body">';  
      if (this.isMobile()) {
        content += '<h5 class="card-title text-uppercase fw-semibold fs-5">' + m.placeResult.name + '</h5>'
      } else {
        content += '<h5 class="card-title text-uppercase fw-semibold fs-3">' + m.placeResult.name + '</h5>'
      }                    
      content += '<p class="card-text m-0"><i class="bi bi-whatsapp"></i>'+m.placeResult.whatsapp+'</p>';
      content += '<p class="card-text m-0"><i class="bi bi-telephone"></i>'+m.placeResult.phone+'</p>';
      if (this.myPos){
        content += `<p class="card-text m-0"><i class="bi bi-pin-map-fill"></i><a href='#' onclick='getItineraire(${ m.position.lat }, ${ m.position.lng }, ${ this.myPos.lat }, ${ this.myPos.lng })' class='percorso'>` + m.placeResult.address + `</p>`;
      }else{
        content += '<p class="card-text m-0"><i class="bi bi-pin-map-fill"></i>'+m.placeResult.address+'</p>';
      }
      content += '<p class="card-text m-0"><i class="bi bi-envelop"></i>'+m.placeResult.email+'</p>';
      if (this.isMobile()) {
        content += '<a class="btn btn-primary btn-sm" href="' + m.placeResult.url + '" title="">' + this.labelVisitaCentro + '</a>';
      }else{
        content += '<a class="btn btn-primary mt-4" href="'+m.placeResult.url+'" title="">'+this.labelVisitaCentro+'</a>';
      }
      content += '</div>';
      content += '</div>';
      
      return content
    },
    reset() {
      this.log('filtrati: '+this.resultsElement.length)
      this.log('markers: '+this.markers.length)
      this.resultsElement = [];
      this.loading = true;
      this.clearResults();
    },
    clearResults() {
      this.place = null;
      this.myPos = null;
      this.zoom = 4;
      this.range = 50;
      this.center = this.latLng;
      this.infoWinOpen = false;
      this.loading = false;
      this.$forceUpdate();
      setTimeout(() => {
        this.resultsElement = this.markers;
        this.fitBounds();
      }, 1000);
    },
    foundLocation(position) {
      const pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      this.$refs.map.panTo(pos);
      this.zoom = 10;
      this.center = pos;
      this.myPos = pos;
      this.range = 50;
      this.log('myPos: ', pos);
    },
    noLocation() {
      this.log("position negata");
    },
    myPosition() {
      const isSupported = 'navigator' in window && 'geolocation' in navigator;
      this.log("isSupported ", isSupported);
      if (isSupported) {
        navigator.geolocation.getCurrentPosition(this.foundLocation, this.noLocation, { timeout: 10000 });
      }else{
        this.log("Geolocation is not supported by this browser.");
      }
    },
    fitBounds() {
      if (this.infoWinOpen) {
        return;
      }
      this.bounds = new window.google.maps.LatLngBounds();

      let ns = 0;
      this.resultsElement.forEach(marker => {
        ns++;
        if (ns < 500)
          this.bounds.extend(marker.position);
      });

      if (!this.bounds.isEmpty()) {
        this.$refs.map.fitBounds(this.bounds);
        // this.$refs.cluster.$clusterObject.setMinimumClusterSize(4);
      } else {
        if (this.place && this.place.geometry){
          this.$refs.map.panTo(this.place.geometry.location);
        }
        if (this.myPos) {
          this.$refs.map.panTo(this.myPos);
          this.zoom = 10;
          this.center = this.myPos;
        }

        this.zoom = 10;
      }
    },
    setPlace(place = null) {
      if (!place)
        return;

      this.place = place;

      this.$forceUpdate();

      if (!this.place.geometry) {
        // Se il valore non è nell'elenco dell'autocomplete -> ERROR
        window.alert("No details available for input: '" + this.place.name + "'");
        return;
      }

      // Se il place ha una geometry, lo mostro.
      if (this.place.geometry) {

        let center = this.place.geometry.location;
        this.center = {
          lat: center.lat(),
          lng: center.lng(),
        };
        this.myPos = null;
        this.resultFilter(this.center);
      }
    },
    resultFilter(pos) {
      this.log('new filter', pos);
      this.bounds = new window.google.maps.LatLngBounds();
      this.resultsElement = [];

      let resultFilter = [];
      let center = new window.google.maps.LatLng(pos.lat, pos.lng);

      for (var i = 0; i < this.markers.length; i++) {
        let latLng = new window.google.maps.LatLng(this.markers[i].position.lat, this.markers[i].position.lng);

        this.markers[i].placeResult.distance = window.google.maps.geometry.spherical.computeDistanceBetween(center, latLng);
        this.markers[i].distance = parseInt(this.markers[i].placeResult.distance);

        if (this.markers[i].distance <= this.radius) {
          // this.log(this.markers[i].placeResult.name,this.markers[i].distance)
          resultFilter.push(this.markers[i]);
          this.bounds.extend(this.markers[i].position);
        }
      }

      if (!this.bounds.isEmpty()) {
        // riordino elenco per vicinanza dal center
        resultFilter.sort((a, b) => b.distance - a.distance);
        this.resultsElement = resultFilter.reverse();

        // this.notFoundLabel = `${this.resultsElement.length} Negozi filtrati - `
        this.fitBounds();
      } else {
        // this.notFoundLabel = "Nessun negozio filtrato - "
        // se non trovo centri nelle vicinanze riposiziono mappa su myPosition
        if(this.myPos){
          this.resultsElement = resultFilter;
          this.log('nessun centro nella tua posizione nel raggio di :'+this.rangeLabel);
          this.$refs.map.panTo(this.myPos);
          this.zoom = 10;
          this.center = this.myPos;
        }
      }
    },
    setMarkersInit(stores) {
      this.markers = [];
      for (var i = 0; i < stores.length; i++) {
        if (parseInt(stores[i].lat) === 0 || parseInt(stores[i].lng) === 0) { continue; }

        let marker = {};
        marker.position = {
          lat: parseFloat(stores[i].lat),
          lng: parseFloat(stores[i].lng)
        };
        marker.placeResult = stores[i];

        this.markers.push(marker);
      }
      this.resultsElement = this.markers;
      this.fitBounds();
      this.loading = false;
    }
  },
  watch: {
    range() {
      this.log('watch range');
      if (this.place) {
        if (this.place.geometry) {
          let center = this.place.geometry.location;
          this.center = {
            lat: center.lat(),
            lng: center.lng(),
          };
          this.resultFilter(this.center);
        }
      } else if (this.myPos) {
        this.resultFilter(this.myPos);
      } else if (this.center){
        this.resultFilter(this.center);
      }
    },
    zoom(value) {
      this.log('zoom: ', value);
    },
    infoWinOpen(value) {
      if(!value)
        this.fitBounds();
    }
  }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/functions";
@import "../../../themes/longevitysuite/src/scss/variables";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/variables-dark";


$secondary-color: #ebedf1;
$button-color: #119199;
$border-color: #080a0a;
$terziary-color: #119199;
$text-color: #333233;
$light-color: var(--bs-light-rgb);

$gray-color: #ABA49D;
$gray-color-light: #F3F5F6;

$size-sm: 480px;
$size-xs: 320px;

#store-locator {
  font-family: "Lato", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .search {
    left: 50px;
    top: 100px;
    z-index: 991;
    width: 390px;
    transition: all .8s ease .4s;

    @media screen and(max-width: $size-sm) {
      left: 20px;
      width: 330px;
    }
    @media screen and(max-width: $size-xs) {
      top: 30px;
      left: 5px;
      width: 300px;
      .form-control{
        font-size: 1rem !important;
      }
      &.position-sticky{
        top: 84px;
      }
    }

    .map-view-lista, .map-view-mappa, .input-group {
      box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.4);
    }

    .form-control:focus {
      outline: none;
    }

    .map-view {
      position: relative;
      z-index: 1;
    }

    .btn {
      padding-top: .7em;
      padding-bottom: .6em;
    }
  }

  .loading{
    z-index: 992;
  }

  .range {
    top: -4em;
    width: calc(100% - 1.5rem);
    .badge {
      background-color: transparent;
      background-image: none;
    }

    .badge::before {
      box-shadow: none;
      background: none;
      color: rgba($primary, 0.6);
      font-size: .5rem;
      position: absolute;
      width: auto;
      content: attr(data-prebadge);
      left: -1em;
      top: 40%;
      transform: rotate(-90deg);
      text-transform: uppercase;
    }
    

    .badge::after {
      transform: none;
      box-shadow: none;
      background: none;
      color: rgba($primary, 0.6);
      font-size: 16px;
      letter-spacing: 0.035em;
      font-weight: 600;
      font-family: "Lato", "Helvetica Neue", Arial, sans-serif;
      position: absolute;
      margin-top: -5px;
      right: 0;
      width: auto;
      text-align: left;
      border: 0px;
      content: attr(data-badge);
    }

    input[type=range] {
      -webkit-appearance: none;
      appearance: none;
      margin: .5rem 0;
      width: 100%;
    }

    

    input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      box-shadow: none;
      background: $gray-color;
      border-radius: 2px;
      border: 0;
    }

    input[type=range]::-webkit-slider-thumb {
      box-shadow: none;
      height: 13px;
      width: 13px;
      border: 0;
      border-radius: 50%;
      background: $gray-color;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -4px;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
      background: #367ebd;
    }

    input[type=range]::-moz-range-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      box-shadow: none;
      background: $gray-color;
      border-radius: 2px;
      border: 0;
    }

    input[type=range]::-moz-range-thumb {
      box-shadow: none;
      height: 13px;
      width: 13px;
      border: 0;
      border-radius: 50%;
      background: $gray-color;
      cursor: pointer;
    }

    input[type=range]::-ms-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      box-shadow: none;
      background: transparent;
      border-color: transparent;
      border-width: 0;
      color: transparent;
    }

    input[type=range]::-ms-fill-lower {
      background: $gray-color;
      border: 0;
      border-radius: 2px;
      box-shadow: none;
    }

    input[type=range]::-ms-fill-upper {
      background: $gray-color;
      border: 0;
      border-radius: 2px;
      box-shadow: none;
    }

    input[type=range]::-ms-thumb {
      box-shadow: none;
      height: 13px;
      width: 13px;
      border: 0;
      border-radius: 50%;
      background: $gray-color;
      cursor: pointer;
    }

    input[type=range]:focus::-ms-fill-lower {
      background: $gray-color;
    }

    input[type=range]:focus::-ms-fill-upper {
      background: $gray-color;
    }
  }

  .container {
    padding-left: 0;
    padding-right: 0;
  }

  .mappa {
    height: calc(100vh - 186px);

    @media screen and(max-width: $size-xs) {
      height: calc(100vh - 133px);
    }
    --bs-gutter-x: 0px;
    --bs-gutter-y: 0px;
  }

  .lista{
    padding-top: 200px;
    z-index: 990;
  }
}

.gm-style .gm-style-iw-c{
  padding: 0px !important;
}

.gm-style-iw-d {
  padding: 0px !important;
  margin: 0px !important;
}

.gm-style-iw-t {
  bottom: 36px !important;
}

.gm-style-iw-c{
  .gm-ui-hover-effect{
    transform: scale(2);
    top: 0px !important;
    right: 0px !important;
  }
}
/**
  Transitions
 */
 // Lista
.translista-enter{
    opacity: 0;

}
.translista-enter-active {
    transition: all .2s ease-in .2s;
}
.translista-enter-to{
    opacity: 1;
}
.translista-leave{
    opacity: 1;
}
.translista-leave-active {
    transition: all .2s ease-in .2s;
}
.translista-leave-to{
    opacity: 0;
}
  // Mappa
.transmappa-enter{
    opacity: 0;
}
.transmappa-enter-active {
    transition: all .2s ease-in .4s;
}
.transmappa-enter-to{
    opacity: 1;
}
.transmappa-leave{
    opacity: 1;
}
.transmappa-leave-active {
    transition: all .2s ease-in 0s;
}
.transmappa-leave-to{
    opacity: 0;
}
</style>